const profile = {
    name: 'Nome',
    avatar: 'Avatar',
    givenName: 'Nome',
    familyName: 'Sobrenome',
    middleName: 'Nome do meio',
    fullName: 'Nome completo',
    nickname: 'Apelido',
    preferredUsername: 'Nome de usuário preferido',
    profile: 'Perfil',
    website: 'Site',
    gender: 'Gênero',
    birthdate: 'Data de nascimento',
    zoneinfo: 'Fuso horário',
    locale: 'Localidade',
    address: {
        formatted: 'Endereço',
        streetAddress: 'Endereço',
        locality: 'Cidade',
        region: 'Estado/Província',
        postalCode: 'CEP',
        country: 'País',
    },
};
export default Object.freeze(profile);
